import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { Box, Link } from '@mui/material'
import { Loading } from 'components/ui'
import { useMappedTranslation } from 'hooks'
import { getGlobalConsentApi } from 'pages/policies/api'
import { Consent, buildPolicySearch } from 'pages/policies/utils'
import List from 'pages/policies/views/list'

import i18n, { convertCountryCode2to3 } from '../../../utils/i18n'

export default function TermsConditionsServiceList() {
  const t = useMappedTranslation()
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [terms, setTerms] = useState<Consent[]>([])
  const [searchParams] = useSearchParams()
  const paramCountryCode = searchParams.get('countryCode') || undefined
  const paramLocale = searchParams.get('locale') || undefined
  const policySearch = buildPolicySearch(searchParams)
  const effectiveCountryCode = paramCountryCode ? convertCountryCode2to3(paramCountryCode) : i18n.countryCode3digit

  const renderAction = () => {
    return (
      <Link
        component='button'
        type='button'
        color='text.secondary'
        sx={{
          fontSize: '16px',
          fontHeight: '24px',
          fontWeight: '700',
          width: '324px',
          pt: { xs: '52px', md: '72px' }
        }}
        onClick={() => navigate(`/policies/terms-conditions/latest${policySearch}`)}
        data-testid='LinkFC8A837E'
      >
        {t('policy.terms.title')}
      </Link>
    )
  }

  const handleListButton = (item) => {
    navigate(`/policies/terms-conditions/services/${item.appKey}/latest${policySearch}`, { state: { consent: item } })
  }

  useEffect(() => {
    getGlobalConsentApi('TC', true, { overrides: { countryCode: paramCountryCode, locale: paramLocale } })
      .then((res) => {
        if (res.status !== 200) {
          throw new Error('Failed getConsentApi')
        } else {
          const data = res.data as Consent[]
          setTerms(data)
          return data
        }
      })
      .catch(() => {
        setTerms([])
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [paramCountryCode, paramLocale])

  return (
    <Box sx={{ width: '100%', height: '100%', paddingTop: { xs: '5px', md: '46px' } }}>
      {isLoading ? (
        <Loading fullScreen />
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ width: { xs: '100%', md: '1040px' } }}>
            <List
              action={effectiveCountryCode === 'KOR' && renderAction()}
              handleListButton={handleListButton}
              title={t('policy.service.title')}
              isLoading={isLoading}
              consents={terms}
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}
